function isEmpty(value) {
  return value === "" || value === null || value === undefined;
}

function isValidPositiveInteger(value) {
  return Number.isInteger(Number(value)) && Number(value) > 0;
}

function validateCityId(value, fieldName) {
  if (isEmpty(value) || !isValidPositiveInteger(value)) {
    return `${fieldName} es obligatorio.`;
  }

  return null;
}

export function validateTarifaCityPayload({
  origin_id,
  destination_id,
  price,
  priceKm,
}) {
  const originIdError = validateCityId(origin_id, "El origen");
  if (originIdError) {
    return originIdError;
  }

  const destinationIdError = validateCityId(destination_id, "El destino");
  if (destinationIdError) {
    return destinationIdError;
  }

  if (isEmpty(price)) {
    return "El precio es obligatorio.";
  }

  if (Number.isNaN(Number(price))) {
    return "El precio debe ser un numero decimal valido.";
  }

  if (Number(price) < 0) {
    return "El precio no puede ser negativo.";
  }

  if (isEmpty(priceKm)) {
    return "El precio por kilometro es obligatorio.";
  }

  if (Number.isNaN(Number(priceKm))) {
    return "El precio por kilometro debe ser un numero decimal valido.";
  }

  if (Number(priceKm) < 0) {
    return "El precio por kilometro no puede ser negativo.";
  }

  return null;
}
